<form class="flex flex-col" [formGroup]="seasonInfo()">
    <h2 class="text-xl font-bold mb-2 text-darkGraySubtitleColor">
        {{ 'seasons.season-creation.season-title.title' | translate }}
    </h2>
    <p class="mb-4 text-base text-darkGraySubtitleColor">
        {{ 'seasons.season-creation.season-title.subtitle' | translate }}
    </p>

    <div class="mb-6 max-w-[400px]">
        <sh-input-text
            [label]="'seasons.season-creation.season-title.title-label' | translate"
            [hint]="'seasons.season-creation.season-title.title-placeholder' | translate"
            formControlName="title"
            mandatory
        />
    </div>
</form>
